import {isEmpty} from "../utils";
import {referralService} from "../service/referral";
import {REFERRAL_TYPE} from "../config";
import {hosService} from "../service/hos";
import {bookService} from "../service/book"

const PAGE_MAP = {
  outpatient: '门诊转诊',
  hospitalization: '住院转诊'
};
export const referralMixin = {
  data() {
    return {
      pages: []
    }
  },
  created() {
    this.setPages();
  },
  watch: {
    $route() {
      this.pages.splice(0);
      this.setPages();
    }
  },
  methods: {
    setPages() {
      const {params, fullPath} = this.$route;
      this.pages.push(PAGE_MAP[params.type]);
      if (fullPath.indexOf('/apply') >= 0) {
        this.pages.push('转诊申请');
      }
    },
    getReferralActionMap() {
      return new Map([
        ['详情', (order) => {
          const {meta} = this.$route;
          this.$router.push({
            path: '/main/referral/detail/' + order.id,
            query: {type: meta.type, referralStatus: order.referralStatus}
          });
        }],
        ['审核通过', () => {
          this.isChecked = true;
        }],
        ['会诊单', order => {
          //this.$refs.print.show(order);
          this.$router.push(`/main/referral/${this.$route.params.type}/report/${order.id}`);
        }],
        ['提交', order => {
          let data = this.$refs.checkForm.getForm();
          this.doReferralAction(data.action, {...order, ...data});
        }],
        ['门诊转诊安排', () => {
          if (!isEmpty(this.arrangeOrder.acceptTime)) {
            return this.$message.info('已经加号成功,请点击提交');
          }
          this.$refs.addNumDialog.showDialog();
        }],
        ['住院转诊安排', () => {
          if (!isEmpty(this.arrangeOrder.acceptTime)) {
            return this.$message.info('床位预约成功,请点击提交');
          }
          let data = this.$refs.checkForm.getForm();
          if (isEmpty(data.acceptDocId)) {
            return this.$message.error('转诊医生不能为空');
          }
          this.$refs.bedNumDialog.show({
            docId: data.acceptDocId
          });
        }],
        ['加号', async order => {
          this.$refs.confirmDialog.show(order);
        }],
        ['确定加号', async (order) => {
          if(await bookService.yygh({
            orgid:order.scheme.orgid,
            channel:"4",
            patnumid:order.num.numid,
            patIdcard:order.order.patIdcard,
            patName:order.order.patName,
            patPhone:order.order.patMobile,
            orderType:"0"
          })){
            this.$refs.endDialog.showSucc('1');
            this.arrangeOrder = {
              acceptDocId:order.acceptDocId,
              id:order.id,
              acceptTime:order.acceptTime,
              referralResult:order.referralResult
            };
            this.$refs.checkForm.setForm('acceptTime', order.acceptTime);
            this.$refs.checkForm.setForm('referralResult', order.referralResult);
          }else{
            this.$refs.endDialog.showSucc('2');
          }
        }],
        ['床位预约', async order => {
          this.$refs.bedConfirmDialog.show(order);
        }],
        ['确定床位预约', async order => {
          this.arrangeOrder = {...order};
          this.$refs.checkForm.setForm('acceptTime', order.acceptTime);
          this.$refs.checkForm.setForm('referralResult', order.referralResult);
        }],
        ['选择号源', order => {
          let data = this.$refs.checkForm.getForm();
          this.$refs.numDialog.show({
            docId: data.acceptDocId, ...order
          });
        }],
        ['取消申请', async (order) => {
          this.$refs['detail_dialog'].start('cancle');
          // this.$prompt('本次转诊未开始，是否确定取消？', '提示', {
          //   confirmButtonText: '确定取消',
          //   cancelButtonText: '再想想',
          //   inputType: 'textarea',
          //   inputPlaceholder: '请输入取消原因',
          //   inputErrorMessage: '取消理由不能为空',
          //   inputValidator: (value) => {
          //     return !isEmpty(value);
          //   },
          // }).then(async ({value}) => {
          //   if (await referralService.cancel({
          //     id: order.id,
          //     refuseReason: value
          //   })) {
          //     this.$notify.success({
          //       title: '提示',
          //       message: '成功取消申请'
          //     });
          //     bus.$emit('top0', 0);
          //     if (this.getDetail) this.getDetail();
          //   }
          // }).catch(() => {
          //
          // });
        }],
        ['资料缺失', async order => {
          if (!order.perfectReason) return this.$message.error('请填写资料缺失理由');
          if (await referralService.askPerfect({
            id: order.id,
            perfectReason: order.perfectReason
          })) {
            this.$notify.success({
              title: '提示',
              message: '操作成功'
            });
            bus.$emit('top0', 0);
            if (this.getDetail) this.getDetail();
          }
        }],
        ['确认补充', async order => {
          let data = this.$refs.conditionForm.getForm();
          if (await referralService.perfect({
            id: order.id,
            ...data
          })) {
            this.$notify.success({
              title: '提示',
              message: '资料已更新'
            });
            this.$router.back();
          }
        }],
        ['资料就绪', async order => {
          if (!order.acceptDocId || !order.acceptTime) return this.$message.error('请填写转诊医生、转诊日期');
          if (await referralService.process({
            id: order.id,
            referralResult: order.referralResult,
            acceptTime: order.acceptTime,
            acceptDocId: order.acceptDocId,
          })) {
            this.$notify.success({
              title: '提示',
              message: '安排成功'
            });
            bus.$emit('top0', 0);
            //if (this.getDetail) this.getDetail();
            this.$router.back();
          }
        }],
        ['安排转诊', async order => {
          if (!order.acceptDocId || !order.acceptTime) return this.$message.error('请填写转诊医生、转诊日期');
          if (await referralService.process({
            id: order.id,
            referralResult: order.referralResult||1,
            acceptTime: order.acceptTime,
            acceptDocId: order.acceptDocId,
            remark:order.remark
          })) {
            this.$notify.success({
              title: '提示',
              message: '安排成功'
            });
            bus.$emit('top0', 0);
            //if (this.getDetail) this.getDetail();
            this.$router.back();
          }
        }],
        ['拒绝申请', async (order) => {
          this.$prompt('本次转诊未开始，是否确定拒绝？', '提示', {
            confirmButtonText: '确定拒绝',
            cancelButtonText: '再想想',
            inputType: 'textarea',
            inputPlaceholder: '请输入拒绝原因',
            inputErrorMessage: '拒绝理由不能为空',
            inputValidator: (value) => {
              return !isEmpty(value);
            },
          }).then(async ({value}) => {
            if (await referralService.refused({
              id: order.id,
              refuseReason: value
            })) {
              this.$notify.success({
                title: '提示',
                message: '成功拒绝申请'
              });
              bus.$emit('top0', 0);
              if (this.getDetail) this.getDetail();
            }
          }).catch(() => {

          });
        }],
        ['再次申请', async order => {
          this.$cache.set('referralOrderCache', order);
          this.$router.push({path:'/main/referral/' + REFERRAL_TYPE.find(r => r.name === order.referralType)['id'] + '/apply',query:{again:true}});
        }],
        ['拒绝转诊', async order => {
          if (!order.refuseReason) return this.$message.error('请填写拒绝理由');
          this.$confirm('本次转诊未开始，是否确定拒绝？', '提示', {
                  confirmButtonText: '确定拒绝',
                  cancelButtonText: '再想想',
              }).then(async () => {
                  if (await referralService.refused({
                      id: order.id,
                      refuseReason: order.refuseReason
                  })) {
                      this.$notify.success({
                          title: '提示',
                          message: '成功拒绝申请'
                      });
                      bus.$emit('top0', 0);
                      if (this.getDetail) this.getDetail();
                  }
          }).catch(() => {

          })
        }],
        ['提交申请', async () => {
          let form = {}, fun = '',vailCount = 0;
          const {doc} = this.loginInfo;
          ['base', 'condition', 'apply'].forEach(r => {
            if(!this.$refs[`${r}Form`].getForm().vail){
              return ;
            }
            vailCount ++;
            form = Object.assign({}, form, this.$refs[`${r}Form`].getForm().form);
          });
          if(vailCount != 3) return
          if (doc.docType === 'DOC') {
            form.initDocId = form.applyDocId;
            form.acceptDocId = form.hopeDocId;
            fun = 'docIssue';
          } else {
            fun = 'assIssue';
            form.initDocId = form.applyDocId;
          }
          if (await referralService[fun](form)) {
            this.$message.success(`${form.referralType}申请提交成功,请耐心等待接收方医院处理。`);
            this.$cache.set('referralOrderCache', null);
            this.$router.push(`/main/referral/${this.$route.params.type}/launch`);
          }
        }],
        ['确定上传', async () => {
          let from = this.$refs['condition'].getAttrList();
          const {code,obj} =  await hosService.loadAtt({
            id:this.info.id,
            ...from
          })
          if(code == "0"){
            this.$message({
              message: '补充资料提交成功。',
              type: 'success'
            });
            this.getDetail();
          }
        }],
        ['门诊安排', async () => {
          let data = this.$refs.checkForm.getForm();
          if (isEmpty(data.acceptDocId)) {
            this.$message.error('转诊医生不能为空');
          } else {
            this.$refs.schemeDialog.show({
              docId: data.acceptDocId
            });
          }
          this.$refs.addNumDialog.hideDialog();
        }]

      ])
    },
    doReferralAction(name, data) {
      const map = this.getReferralActionMap();
      const action = [...map].find(r => r[0] === name);
      if (isEmpty(action)) this.$message.error(`未定义 ${name} 操作`);
      else action[1](data);
    }
  },
}
